import { createFileRoute } from "@tanstack/react-router";
import PartsQuoteView from "@/pages/PartsQuoteView";

export const Route = createFileRoute("/parts-catalog/quote/$token")({
  component: PartsQuoteView,
  head: () => ({
    meta: [
      { title: "Your Parts Quote | Rex & Sons RV Parts" },
      { name: "description", content: "Review the parts quote prepared for you and check out at the quoted price." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Your Parts Quote | Rex & Sons RV Parts" },
      { property: "og:description", content: "Review your parts quote and check out at the quoted price." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});
